module.exports = __webpack_public_path__ + "img/Union.6f9f9e7c.png";